module.exports = __webpack_public_path__ + "ab175e712fb6502dfc4dd454a7048d43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-beach-s.png
// module id = 2468
// module chunks = 0